import betaSettings from '../../config/settings/beta.json';
import developmentSettings from '../../config/settings/development.json';
import stagingSettings from '../../config/settings/staging.json';
import productionSettings from '../../config/settings/production.json';
import localSettings from '../../config/settings/local.json';
import defaultSettings from '../../config/settings/default.json';

const getEnvSettingsFile = (environment) => {
    switch (environment) {
        case 'beta':
            return betaSettings;
        case 'development':
            return developmentSettings;
        case 'staging':
            return stagingSettings;
        case 'production':
            return productionSettings;
        default:
            return localSettings;
    }
};

export const getEnvironmentSettings = (environment) => ({ ...defaultSettings, ...getEnvSettingsFile(environment) });
